import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

/**
 * Loading interceptor that tracks in-flight HTTP requests.
 * Increments the loading counter on request start, decrements on completion (success or error).
 * Must be registered FIRST in the interceptor chain to track all requests.
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  loadingService.startRequest();

  return next(req).pipe(
    finalize(() => loadingService.endRequest()),
  );
};